import { gql } from '@apollo/client'

export const LOAD_CLUB_COURSES_QUERY = gql`
  query GetClubCourses($clubId: ID!) {
    CoursesQuery {
      clubCourses(clubId: $clubId) # clubCourses returns JSON scalar values directly
    }
  }
`

export const ARCHIVE_COURSE_MUTATION = gql`
  mutation ArchiveCourse($courseId: ID!) {
    CoursesMutation {
      archiveCourse(courseId: $courseId) {
        id
        archivedAt
      }
    }
  }
`

export const UNARCHIVE_COURSE_MUTATION = gql`
  mutation UnarchiveCourse($courseId: ID!) {
    CoursesMutation {
      unarchiveCourse(courseId: $courseId) {
        id
        archivedAt
      }
    }
  }
`
